module.exports = __webpack_public_path__ + "img/pattern.png?5ff3736d825898b789431b4f735e3fec";